<template>
  <div
    class="mt-28 md:mt-36 flex gap-6 md:gap-10 px-6 md:max-w-6xl justify-between w-full items-end"
  >
    <h2
      class="uppercase font-medium text-20 font-druk-wide md:text-32"
      v-html="title"
    ></h2>
    <div class="hidden md:flex gap-6">
      <button
        value="prev"
        aria-label="Previous"
        class="manager-pros-swiper-prev h-8 w-8 bg-grayscale-13 hover:bg-grayscale-30 rounded-full flex justify-center items-center"
      >
        <i class="icon-left text-24" />
      </button>
      <button
        value="next"
        aria-label="Next"
        class="manager-pros-swiper-next h-8 w-8 bg-grayscale-13 hover:bg-grayscale-30 rounded-full flex justify-center items-center"
      >
        <i class="icon-right text-24" />
      </button>
    </div>
  </div>
  <div class="w-full mt-6 md:mt-10 relative">
    <ClientOnly>
      <swiper
        passiveListeners
        :slidesPerView="'auto'"
        :spaceBetween="8"
        :freeMode="true"
        :mousewheel="true"
        :keyboard="true"
        :navigation="{
          nextEl: '.manager-pros-swiper-next',
          prevEl: '.manager-pros-swiper-prev',
        }"
        :breakpoints="{
          300: {
            allowTouchMove: true,
            slidesPerGroupAuto: false,
          },
          1024: {
            allowTouchMove: true,
            slidesPerGroupAuto: true,
          },
        }"
        :modules="[FreeMode, Navigation, Mousewheel, Keyboard]"
        class="carousel-padding"
      >
        <swiper-slide v-for="pro in pros" :key="pro._id" class="w-auto">
          <pro
            class="carousel__item m-2 w-211px transform hover:scale-105 duration-300 ease-in-out"
            :pro="pro"
          />
        </swiper-slide>
      </swiper>
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
import { FreeMode, Navigation, Mousewheel, Keyboard } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import type { User } from "@/types/user";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/mousewheel";
import "swiper/css/keyboard";

const props = defineProps({
  pros: {
    type: Array as PropType<User[]>,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
});
</script>

<style scoped>
.carousel-padding {
  padding-left: 24px;
  padding-right: 24px;
}

@media (min-width: 768px) {
  .carousel-padding {
    padding-left: calc((100vw - 1152px) / 2);
    padding-right: calc((100vw - 1152px) / 2);
  }
}

.swiper-slide {
  width: auto;
}
</style>
